<script setup lang="ts">
  import { getFlagByCountryCode } from "@utils/constants/regions";
  import type { HistoAudience } from "@/components/Admin/Histo/HistoDataTable/types";

  defineProps<{
    audiences: Record<string, HistoAudience[]>;
    isMultiCountry: boolean;
  }>();

  function getCostShare(item: { cost_share?: number }): number {
    if (!item?.cost_share) return 0;
    return Math.round(item.cost_share * 100);
  }
</script>

<template>
  <section>
    <h3 class="heading-section mb-3">Top audiences</h3>
    <template v-if="Object.keys(audiences).length">
      <template
        v-for="(items, country) in audiences"
        :key="country">
        <div
          v-if="isMultiCountry"
          class="mb-2">
          <span class="font-medium text-sm text-foreground">
            {{ getFlagByCountryCode(country as string) }} {{ country }}
          </span>
        </div>
        <ul class="space-y-2 mb-4">
          <li
            v-for="(audience, idx) in items"
            :key="`audience-${idx}`"
            class="text-sm">
            <span class="font-medium text-foreground">{{ getCostShare(audience) }}%</span>
            <span class="text-foreground/80"> - {{ audience.audience_name }}</span>
            <span class="text-foreground/60 text-xs"> ({{ audience.campaign_name }})</span>
          </li>
        </ul>
      </template>
    </template>
    <p
      v-else
      class="text-sm text-foreground/50 italic">
      No audiences available
    </p>
  </section>
</template>
